var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71009 16.29L5.41009 12L9.71009 7.71004L8.29009 6.29004L2.59009 12L8.29009 17.71L9.71009 16.29ZM15.7101 17.71L21.4101 12L15.7101 6.29004L14.2901 7.71004L18.5901 12L14.2901 16.29L15.7101 17.71Z",
    fill: "#A0ACB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeLogo);
export default __webpack_public_path__ + "static/media/codeLogo.3b12c713cefe7ebb1a8a87a0543e0762.svg";
export { ForwardRef as ReactComponent };